import AuthService from '../../utilities/services/auth.service'

import { FlexPackageSalesSummaryWrapper } from '../../components'

export default function FlexPackageSalesSummaryPage() {
  const organization = AuthService.getOrg()[0]

  return <FlexPackageSalesSummaryWrapper organization={organization} />
}
